const MatiereList = {
  SciencesHumainesSociales: [
    { id: 1, Matiere_Name: 'Histoire', Matiere_Color: '', Matiere_Description: '' },
    { id: 2, Matiere_Name: 'Géographie', Matiere_Color: '', Matiere_Description: '' },
    { id: 3, Matiere_Name: 'Études sociales', Matiere_Color: '', Matiere_Description: '' },
    { id: 4, Matiere_Name: 'Éducation civique', Matiere_Color: '', Matiere_Description: '' },
    { id: 5, Matiere_Name: 'Économie', Matiere_Color: '', Matiere_Description: '' },
    { id: 6, Matiere_Name: 'Psychologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 7, Matiere_Name: 'Sociologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 8, Matiere_Name: 'Philosophie', Matiere_Color: '', Matiere_Description: '' },
    { id: 9, Matiere_Name: 'Études religieuses', Matiere_Color: '', Matiere_Description: '' },
    { id: 10, Matiere_Name: 'Anthropologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 11, Matiere_Name: 'Archéologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 12, Matiere_Name: 'Science politique', Matiere_Color: '', Matiere_Description: '' },
    { id: 13, Matiere_Name: 'Études culturelles', Matiere_Color: '', Matiere_Description: '' },
    { id: 14, Matiere_Name: 'Éthique', Matiere_Color: '', Matiere_Description: '' }
  ],
  LanguesLitterature: [
    { id: 15, Matiere_Name: 'Langue et littérature françaises', Matiere_Color: '', Matiere_Description: '' },
    { id: 16, Matiere_Name: 'Écriture créative', Matiere_Color: '', Matiere_Description: '' },
    { id: 17, Matiere_Name: 'Grammaire et composition', Matiere_Color: '', Matiere_Description: '' },
    { id: 18, Matiere_Name: 'Littérature mondiale', Matiere_Color: '', Matiere_Description: '' },
    { id: 19, Matiere_Name: 'Poésie', Matiere_Color: '', Matiere_Description: '' },
    { id: 20, Matiere_Name: 'Théâtre et écriture de pièces', Matiere_Color: '', Matiere_Description: '' },
    { id: 21, Matiere_Name: 'Journalisme', Matiere_Color: '', Matiere_Description: '' },
    { id: 22, Matiere_Name: 'Linguistique', Matiere_Color: '', Matiere_Description: '' },
    { id: 23, Matiere_Name: 'Compréhension de lecture', Matiere_Color: '', Matiere_Description: '' }
  ],
  Mathematiques: [
    { id: 24, Matiere_Name: 'Arithmétique', Matiere_Color: '', Matiere_Description: '' },
    { id: 25, Matiere_Name: 'Algèbre', Matiere_Color: '', Matiere_Description: '' },
    { id: 26, Matiere_Name: 'Géométrie', Matiere_Color: '', Matiere_Description: '' },
    { id: 27, Matiere_Name: 'Trigonométrie', Matiere_Color: '', Matiere_Description: '' },
    { id: 28, Matiere_Name: 'Calcul différentiel et intégral', Matiere_Color: '', Matiere_Description: '' },
    { id: 29, Matiere_Name: 'Statistiques', Matiere_Color: '', Matiere_Description: '' },
    { id: 30, Matiere_Name: 'Probabilités', Matiere_Color: '', Matiere_Description: '' },
    { id: 31, Matiere_Name: 'Mathématiques discrètes', Matiere_Color: '', Matiere_Description: '' },
    { id: 32, Matiere_Name: 'Mathématiques appliquées', Matiere_Color: '', Matiere_Description: '' }
  ],
  Sciences: [
    { id: 33, Matiere_Name: 'Physique', Matiere_Color: '', Matiere_Description: '' },
    { id: 34, Matiere_Name: 'Chimie', Matiere_Color: '', Matiere_Description: '' },
    { id: 35, Matiere_Name: 'Biologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 36, Matiere_Name: 'Sciences de l\'environnement', Matiere_Color: '', Matiere_Description: '' },
    { id: 37, Matiere_Name: 'Géosciences', Matiere_Color: '', Matiere_Description: '' },
    { id: 38, Matiere_Name: 'Astronomie', Matiere_Color: '', Matiere_Description: '' },
    { id: 39, Matiere_Name: 'Géologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 40, Matiere_Name: 'Météorologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 41, Matiere_Name: 'Anatomie et physiologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 42, Matiere_Name: 'Botanique', Matiere_Color: '', Matiere_Description: '' },
    { id: 43, Matiere_Name: 'Zoologie', Matiere_Color: '', Matiere_Description: '' },
    { id: 44, Matiere_Name: 'Écologie', Matiere_Color: '', Matiere_Description: '' }
  ],
  LanguesEtrangeres: [
    { id: 45, Matiere_Name: 'Espagnol', Matiere_Color: '', Matiere_Description: '' },
    { id: 46, Matiere_Name: 'Français', Matiere_Color: '', Matiere_Description: '' },
    { id: 47, Matiere_Name: 'Allemand', Matiere_Color: '', Matiere_Description: '' },
    { id: 48, Matiere_Name: 'Mandarin', Matiere_Color: '', Matiere_Description: '' },
    { id: 49, Matiere_Name: 'Italien', Matiere_Color: '', Matiere_Description: '' },
    { id: 50, Matiere_Name: 'Japonais', Matiere_Color: '', Matiere_Description: '' },
    { id: 51, Matiere_Name: 'Arabe', Matiere_Color: '', Matiere_Description: '' },
    { id: 52, Matiere_Name: 'Russe', Matiere_Color: '', Matiere_Description: '' },
    { id: 53, Matiere_Name: 'Latin', Matiere_Color: '', Matiere_Description: '' },
    { id: 54, Matiere_Name: 'Grec', Matiere_Color: '', Matiere_Description: '' },
    { id: 55, Matiere_Name: 'Portugais', Matiere_Color: '', Matiere_Description: '' },
    { id: 56, Matiere_Name: 'Coréen', Matiere_Color: '', Matiere_Description: '' }
  ],
  BeauxArts: [
    { id: 57, Matiere_Name: 'Arts visuels (dessin, peinture, sculpture)', Matiere_Color: '', Matiere_Description: '' },
    { id: 58, Matiere_Name: 'Musique (instrumentale, vocale, théorie musicale)', Matiere_Color: '', Matiere_Description: '' },
    { id: 59, Matiere_Name: 'Danse', Matiere_Color: '', Matiere_Description: '' },
    { id: 60, Matiere_Name: 'Arts du théâtre (acting, mise en scène, scénographie)', Matiere_Color: '', Matiere_Description: '' },
    { id: 61, Matiere_Name: 'Études cinématographiques', Matiere_Color: '', Matiere_Description: '' },
    { id: 62, Matiere_Name: 'Photographie', Matiere_Color: '', Matiere_Description: '' },
    { id: 63, Matiere_Name: 'Graphisme', Matiere_Color: '', Matiere_Description: '' },
    { id: 64, Matiere_Name: 'Design de mode', Matiere_Color: '', Matiere_Description: '' }
  ],
  SanteEducationphysique : [
    { id: 1, Matiere_Name: "Éducation physique (sports, fitness, sciences de l'exercice)", Matiere_Color: "", Matiere_Description: "" },
    { id: 2, Matiere_Name: "Éducation à la santé", Matiere_Color: "", Matiere_Description: "" },
    { id: 3, Matiere_Name: "Nutrition", Matiere_Color: "", Matiere_Description: "" },
    { id: 4, Matiere_Name: "Premiers secours", Matiere_Color: "", Matiere_Description: "" },
    { id: 5, Matiere_Name: "Développement personnel", Matiere_Color: "", Matiere_Description: "" },
    { id: 6, Matiere_Name: "Médecine du sport", Matiere_Color: "", Matiere_Description: "" },
    { id: 7, Matiere_Name: "Yoga et méditation", Matiere_Color: "", Matiere_Description: "" }
  ],
  TechnologieInformatique : [
    { id: 1, Matiere_Name: "Informatique (programmation, algorithmes)", Matiere_Color: "", Matiere_Description: "" },
    { id: 2, Matiere_Name: "Technologies de l'information", Matiere_Color: "", Matiere_Description: "" },
    { id: 3, Matiere_Name: "Culture numérique", Matiere_Color: "", Matiere_Description: "" },
    { id: 4, Matiere_Name: "Développement web", Matiere_Color: "", Matiere_Description: "" },
    { id: 5, Matiere_Name: "Génie logiciel", Matiere_Color: "", Matiere_Description: "" },
    { id: 6, Matiere_Name: "Gestion de base de données", Matiere_Color: "", Matiere_Description: "" },
    { id: 7, Matiere_Name: "Réseautique", Matiere_Color: "", Matiere_Description: "" },
    { id: 8, Matiere_Name: "Cybersécurité", Matiere_Color: "", Matiere_Description: "" }
  ],
  EducationProfessionnelleTechnique : [
    { id: 1, Matiere_Name: "Études commerciales (comptabilité, entrepreneuriat, marketing)", Matiere_Color: "", Matiere_Description: "" },
    { id: 2, Matiere_Name: "Économie domestique (cuisine, couture, finances personnelles)", Matiere_Color: "", Matiere_Description: "" },
    { id: 3, Matiere_Name: "Technologie automobile", Matiere_Color: "", Matiere_Description: "" },
    { id: 4, Matiere_Name: "Menuiserie", Matiere_Color: "", Matiere_Description: "" },
    { id: 5, Matiere_Name: "Travail des métaux", Matiere_Color: "", Matiere_Description: "" },
    { id: 6, Matiere_Name: "Électronique", Matiere_Color: "", Matiere_Description: "" },
    { id: 7, Matiere_Name: "Métiers de la construction", Matiere_Color: "", Matiere_Description: "" },
    { id: 8, Matiere_Name: "Coiffure et esthétique", Matiere_Color: "", Matiere_Description: "" },
    { id: 9, Matiere_Name: "Arts culinaires", Matiere_Color: "", Matiere_Description: "" }
  ]
};


export default MatiereList